import {
  filter,
  find,
  flatten,
  get,
  isEmpty,
  keys,
  map,
  mapValues,
  split,
  values,
} from 'lodash'

import { INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FIELD_NAMES } from '../../constants'

const transformToSaveIngredientCommonNegativeSynonymPhrasesArgs = data =>
  filter(
    flatten(
      values(
        mapValues(data, (value, key) =>
          map(split(value, '\n'), phrase => ({
            phrase,
            type: find(
              keys(INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FIELD_NAMES),
              type =>
                get(
                  INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FIELD_NAMES,
                  type,
                ) === key,
            ),
          })),
        ),
      ),
    ),
    ({ phrase }) => !isEmpty(phrase),
  )

export default transformToSaveIngredientCommonNegativeSynonymPhrasesArgs
